import { RestEndpoint } from '@data-client/rest';
export class BaseEndpoint extends RestEndpoint {
    constructor() {
        super(...arguments);
        this.urlPrefix = process.env.API_URL ||
            process.env.REACT_APP_API_URL ||
            'http://localhost:8000';
    }
    async getHeaders(headers) {
        return {
            ...(await super.getHeaders(headers)),
            'Content-Type': 'application/json',
            Accept: '*/*'
        };
    }
}
